import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { MatrixClassService } from "@services/matrix-class"
import { MatrixClass } from "@models/matrix-class"
import { Course } from "@models/course"
import { Contact } from "@models/contact"
import {
  FETCH_CLASSES,
  POPULATE_CLASSES,
  FETCH_CLASSES_FAILURE,
  CREATE_CLASS,
  ADD_CLASS,
  CREATE_CLASS_FAILURE,
  FETCH_CLASS_FAILURE,
  POPULATE_ACTIVE_CLASS,
  FETCH_CLASS,
  FETCH_TEACHERS_FAILURE,
  POPULATE_TEACHERS,
  FETCH_TEACHERS,
  REPLACE_CLASS,
  UPDATE_CLASS_FAILURE,
  UPDATE_CLASS,
  FETCH_CLASSSES_FOR_TO_TERM,
  POPULATE_CLASSSES_FOR_TO_TERM,
  POPULATE_CLASSSES_FOR_FROM_TERM,
  FETCH_CLASSSES_FOR_FROM_TERM,
  CLASS_ROLLOVER,
  POPULATE_CLASS_ROLLOVER_RESULT
} from "../matrix-class"
import { Observable } from "rxjs/Observable"

@Injectable()
export class MatrixClassEffects {

  constructor(
    private actions: Actions,
    private matrixClassService: MatrixClassService
  ) {}

  @Effect() fetchClasses = this.actions
    .ofType(FETCH_CLASSES)
    .debounceTime(300)
    .switchMap((action: Action) => this.matrixClassService.index(action.payload)
      .map((classes: MatrixClass[]) => ({ type: POPULATE_CLASSES, payload: classes }))
      .catch(() => Observable.of({ type: FETCH_CLASSES_FAILURE }))
    )
    .share()

  @Effect() fetchClass = this.actions
    .ofType(FETCH_CLASS)
    .switchMap((action: Action) => this.matrixClassService.fetch(action.payload)
      .map((matrixClass: MatrixClass) => ({ type: POPULATE_ACTIVE_CLASS, payload: matrixClass }))
      .catch(() => Observable.of({ type: FETCH_CLASS_FAILURE }))
    )
    .share()

  @Effect() fetchTeachers = this.actions
    .ofType(FETCH_TEACHERS)
    .switchMap((action: Action) => this.matrixClassService.teachers()
      .map((teachers: Contact[]) => ({ type: POPULATE_TEACHERS, payload: teachers }))
      .catch(() => Observable.of({ type: FETCH_TEACHERS_FAILURE }))
    )
    .share()

  @Effect() createClass = this.actions
    .ofType(CREATE_CLASS)
    .map((action: Action) => action.payload)
    .switchMap((matrixClass: MatrixClass) => this.matrixClassService.create(matrixClass.serializeForRails())
      .map((matrixClass: MatrixClass) => ({ type: ADD_CLASS, payload: matrixClass }))
      .catch((response: any) => Observable.of({ type: CREATE_CLASS_FAILURE, payload: response }))
    )
  .share()

  @Effect() updateClass = this.actions
    .ofType(UPDATE_CLASS)
    .map((action: Action) => action.payload)
    .switchMap((matrixClass: MatrixClass) => this.matrixClassService.update(matrixClass.serializeForRails())
      .map((matrixClass: MatrixClass) => ({ type: REPLACE_CLASS, payload: matrixClass }))
      .catch((response: any) => Observable.of({ type: UPDATE_CLASS_FAILURE, payload: response }))
    )
  .share()

  @Effect() fetchClassesToTerm = this.actions
    .ofType(FETCH_CLASSSES_FOR_TO_TERM)
    .map((action: Action) => action.payload)
    .switchMap((termId: number) => { 
      return this.matrixClassService.index({ termId })
        .map((classes: MatrixClass[]) => ({ type: POPULATE_CLASSSES_FOR_TO_TERM, payload: classes }))
    })

  @Effect() fetchClassesFromTerm = this.actions
    .ofType(FETCH_CLASSSES_FOR_FROM_TERM)
    .map((action: Action) => action.payload)
    .switchMap((termId: number) => { 
      return this.matrixClassService.index({ termId })
        .map((classes: MatrixClass[]) => ({ type: POPULATE_CLASSSES_FOR_FROM_TERM, payload: classes }))
    })

  @Effect() classRollover = this.actions
    .ofType(CLASS_ROLLOVER)
    .map((action: Action) => action.payload)
    .switchMap((params: any) => { 
      return this.matrixClassService.rollover(params)
        .map((classes: MatrixClass[]) => ({ type: POPULATE_CLASS_ROLLOVER_RESULT, payload: classes }))
    })

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/matrix-class.ts